/**
 * One N-Triples line read into its three terms: the one tokenizer of the web app (F102 W-07).
 * Callers decide by exact IRIs (`RDF_TYPE`), never by a local name.
 */

export const RDF_TYPE = "http://www.w3.org/1999/02/22-rdf-syntax-ns#type";

export type RdfTerm =
  | { readonly kind: "iri"; readonly iri: string }
  | { readonly kind: "blank"; readonly label: string }
  | { readonly kind: "literal"; readonly text: string; readonly language: string | null };

export interface RdfTriple {
  readonly subject: RdfTerm;
  readonly predicate: string;
  readonly object: RdfTerm;
}

const TERM = /^<([^>]*)>|^(_:\S+)|^"((?:[^"\\]|\\.)*)"(?:@([A-Za-z0-9-]+)|\^\^<[^>]*>)?/;

/** The line's three terms, or `null` if it is not an N-Triples line with an IRI predicate. */
export function parseNTriple(line: string): RdfTriple | null {
  let rest = line.trim();
  const terms: RdfTerm[] = [];
  for (let index = 0; index < 3; index += 1) {
    const match = TERM.exec(rest);
    if (match === null) return null;
    terms.push(termOf(match));
    rest = rest.slice(match[0].length).trimStart();
  }
  const [subject, predicate, object] = terms;
  if (subject === undefined || predicate?.kind !== "iri" || object === undefined) return null;
  return { subject, predicate: predicate.iri, object };
}

function termOf(match: RegExpExecArray): RdfTerm {
  const [, iri, blankNode, text, language] = match;
  if (iri !== undefined) return { kind: "iri", iri };
  if (blankNode !== undefined) return { kind: "blank", label: blankNode };
  return { kind: "literal", text: unescaped(text ?? ""), language: language ?? null };
}

function unescaped(text: string): string {
  return text.replace(/\\(["\\nrt])/g, (_whole, character: string) => {
    switch (character) {
      case "n":
        return "\n";
      case "r":
        return "\r";
      case "t":
        return "\t";
      default:
        return character;
    }
  });
}
